module.exports = __webpack_public_path__ + "static/ferry-background-1e96bd6f41848bada6293606363ba41c.png";